import { render } from "./MicrositioNew.vue?vue&type=template&id=783e5fee&scoped=true"
import script from "./MicrositioNew.vue?vue&type=script&lang=js"
export * from "./MicrositioNew.vue?vue&type=script&lang=js"

import "./MicrositioNew.vue?vue&type=style&index=0&id=783e5fee&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783e5fee"]])

export default __exports__